import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const GowanbraePage = () => <LocationTemplate suburbName="Gowanbrae" suburbSlug="gowanbrae" />;

export default GowanbraePage;
